<template>
  <div class="comment-file">
    <FontAwesomeIcon class="comment-file__icon" :icon="['fas', icon]" />
    <div class="comment-file__info">
      <a v-if="value.url" :href="value.url" :title="title" @click.prevent="action" class="comment-file__name">{{
        value.name
      }}</a>
      <div class="comment-file__info-footer">
        <span v-if="value.size" class="comment-file__info-size">{{ value.size | size }}</span>
      </div>
    </div>
    <button
      :title="titles['download']"
      v-if="isDownloadable"
      @click="() => handlers.download(value)"
      class="comment-file__download"
    >
      <FontAwesomeIcon :icon="['fas', 'download']" />
    </button>
  </div>
</template>
<script>
import { DownloadUrl, BytesToSize, Capitalize } from '@/utils'

const filePatterns = [
  { pattern: /text.*/, icon: 'file-alt', action: 'download' },
  { pattern: /image.*/, icon: 'file-image', action: 'open' },
  { pattern: /pdf/, icon: 'file-pdf', action: 'open' },
  { pattern: /word/, icon: 'file-word', action: 'download' },
  { pattern: /excel/, icon: 'file-excel', action: 'download' },
  { pattern: /powerpoint/, icon: 'file-powerpoint', action: 'download' },
  { pattern: /octet-stream|zip/, icon: 'file-archive', action: 'download' },
  { pattern: /download/, icon: 'file', action: 'download' },
  { pattern: /url/, icon: 'external-link', action: 'link' },
]

const FileHandlers = {
  download(file) {
    DownloadUrl(file.url, file.name)
  },
  open(file) {
    window.open(file.url, '_blank')
  },
  link(file) {
    window.open(file.url, '_blank')
  },
}

export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    titles() {
      const type = this.$tc(this.item.icon.split('-').pop(), 1).toLowerCase()

      return {
        open: Capitalize(this.$t('openX', { x: type })),
        download: Capitalize(this.$t('downloadX', { x: type })),
      }
    },
    title() {
      return ['open', 'link'].includes(this.item.action) ? this.titles['open'] : this.titles['download']
    },
    handlers() {
      return FileHandlers
    },
    isDownloadable() {
      return this.item.action !== 'link'
    },
    item() {
      return (
        filePatterns.find(({ pattern }) => pattern.test(this.value.type || 'download')) || {
          icon: 'file',
          action: 'download',
        }
      )
    },
    icon() {
      return this.item.icon
    },
    action() {
      return this.handlers[this.item.action](this.value)
    },
  },
  filters: {
    size: BytesToSize,
  },
}
</script>

<style lang="scss">
.comment-file {
  line-height: 1;
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  background-color: white;
  color: inherit;
  width: 100%;

  &__icon {
    font-size: 1.2em;
    opacity: 0.5;
    max-width: 15px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    &-footer {
      display: flex;
      align-items: center;
      margin-top: 0.2rem;
    }

    &-size {
      font-size: 0.8em;
      margin-right: 1rem / 2;
      opacity: 0.75;
    }
  }

  &__name {
    font: inherit;
    font-weight: bold;
    transition: background-color 150ms ease-out;
    color: inherit !important;
    border: none;
    border-radius: GetVariable('border-radius');
    background-color: transparent;

    &:hover:not(:disabled) {
      background-color: GetVariable('border-color');
    }
  }

  &__download {
    margin-left: auto;
    cursor: pointer;
    opacity: 0.5;
    svg {
      font-size: 1rem;
    }
  }
}
</style>
